module.exports = __webpack_public_path__ + "img/user-icon.d821f23b.svg";